"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RichTextEditor;
var _react = _interopRequireWildcard(require("react"));
var _plateCommon = require("@udecode/plate-common");
var _tooltip = require("../../../../plate-js/plate-ui/tooltip");
var _fixedToolbar = require("../../../../plate-js/plate-ui/fixed-toolbar");
var _fixedToolbarButtons = require("../../../../plate-js/plate-ui/fixed-toolbar-buttons");
var _editorComponent = require("../../../../plate-js/plate-ui/editor-component");
var _RichTextEditorConfiguration = require("./RichTextEditorConfiguration");
var _plateCore = require("@udecode/plate-core");
var _mentionContext = require("../../../../plate-js/lib/mentionContext");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Based on platejs
 * We are stuck on v36 until we can upgrade react to 18
 * V36 documentation: https://v36.platejs.org/docs
 * The CLI tool does not generate correct files for v36 so the controls are manually copied from the website
 * The configuration is in RichTextEditorConfiguration.ts - check the commented out plugins list for a list of available plugins
 *
 * If, for some reason, you need to update the tailwind styles, please run this command:
 * "npx tailwindcss -i ./src/plate-js/plateStyles.css -o ./src/public/plateStylesCompiled.css"
 *  This will generate a new tailwind file in ./src/public/
 *  Now examine the diff and make sure to recreate the manual changes that added .plate-editor-wrapper around individual element
 *  styles as well as replacing global elements (hmll, body, root etc.) with .plate-editor-wrapper
 *  Finally the css files need to be copied to web-front public folder manually.
 *  We can automate this in the future, but the global css needs to be loaded in the web-front index.html file
 *
 * */

function RichTextEditor(props) {
  var initialValue = props.initialValue,
    initialHtml = props.initialHtml,
    onChange = props.onChange,
    onBlur = props.onBlur,
    peopleMentions = props.peopleMentions,
    labelMentions = props.labelMentions,
    pluginToggles = props.pluginToggles,
    dataCy = props['data-cy'];
  var plugins = (0, _RichTextEditorConfiguration.getMinimalPlugins)(pluginToggles);
  var initialValueFromHtml = (0, _react.useMemo)(function () {
    if (!initialHtml) {
      return undefined;
    }
    var tmpEditor = (0, _plateCommon.createPlateEditor)({
      plugins: plugins
    });
    return (0, _plateCore.deserializeHtml)(tmpEditor, {
      element: initialHtml || ''
    });
  }, [initialHtml, plugins]);

  // deserializeHtml output is not 100% type compatible with initialValue, so we need to cast it
  // this is one of those things that need to be revisited when upgrading to the latest version of Plate
  var editorValue = initialValueFromHtml || initialValue;
  var onChangeHandler = function onChangeHandler(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
  };
  var onBlurHandler = function onBlurHandler(html) {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(html);
  };
  return (/*#__PURE__*/
    /* PlateStoreProvider should not be necessary here, according to the docs, but it forces the plate store
     * to be initialized before the Plate component and this makes it work in web-front */
    (0, _jsxRuntime.jsx)("div", {
      "data-cy": dataCy + '-container',
      className: 'plate-editor-wrapper',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mentionContext.MentionProvider, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_plateCore.PlateStoreProvider, {
          id: 'plate',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.TooltipProvider, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_plateCommon.Plate, {
              id: 'plate',
              plugins: plugins,
              initialValue: editorValue,
              onChange: onChangeHandler,
              readOnly: false,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_editorComponent.EditorComponent, {
                autoFocus: true,
                focusRing: false,
                size: "md",
                onBlurHandler: onBlurHandler,
                peopleMentions: peopleMentions,
                labelMentions: labelMentions,
                "data-cy": dataCy
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fixedToolbar.FixedToolbar, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fixedToolbarButtons.FixedToolbarButtons, {})
              })]
            })
          })
        })
      })
    })
  );
}